export enum WebhookEventsActionType {
  GetWebhookEvents = 'webhookEvents/getWebhookEvents',
  DeleteWebhookEvent = 'webhookEvents/deleteWebhookEvent',
  RetryWebhookEvent = 'webhookEvents/retryWebhookEvent',
  SaveWebhookEvents = 'webhookEvents/saveWebhookEvents',
}
